import * as API from "./Api";

export const getNotifications = (page = 1, limit = 10) =>
  API.get(`notifications?page=${page}&limit=${limit}`);
